import { Fragment, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import UserInfo from "src/components/common/userInfo";
import Footer from "src/components/common/frame/footer";
import { useMyStore } from "src/components/main/mainStore";
import {
    weeknum, 
    getDatefromWeekNum, 
    MyDate, 
    myAxios, 
    MyFormData, 
    getTimeStamp, 
    boolAndReducer, 
    scroll, 
    isDevMode,
    appTitle, 
    simpleStatusColorCode,
    arrayReducer,
    onlyUnique, 
} from "src/components/common/functions";
import BillingForm from "./billingForm";
import Export from "./export";
import Detail from "./detail";
import WeekSelect from "../common/frame/weekSelect";
import DataFilter from "../common/frame/dataFilter";
//--------------------------------------------------------------------------------------------
export default function Billings({ tabTitle }){
    const dataFrame = [
        {label: "Void", key: "void", type: "select", options: [
            {value: "", label: "No"}, {value: "All", label: "All"}, {value: "yes", label: "Yes"}
        ]}, 
        {label: "Billing Number", key: "billingNumber"}, 
        {label: "Start Date", key: "startDate", type: "date"}, 
        {label: "End Date", key: "endDate", type: "date"}, 
        {label: "Project", key: "projectName"}, 
        {label: "Amount", key: "amount", type: "number"}, 
        {label: "Notes", key: "notes", noList: true}, 
        {label: "Approver", key: "approver", type: "select", options: []}, 
        {label: "Status", key: "decision", default: "All", type: "select", options: [
            {value: "All", label: "All"}, 
            {value: "Submitted", label: "Submitted"}, 
            {value: "Approved", label: "Approved"}, 
            {value: "Rejected", label: "Rejected"}
        ]}, 
        {label: "Billed", key: "billed", default: "All", type: "select", options: [
            {value: "All", label: "All"}, {value: "yes", label: "Yes"}, {value: "", label: "No"}
        ]}, 
        {label: "Created By", key: "submitter"}, 
        {label: "Submit Time", key: "submitTime", type: "date"}, 
        {label: "Updated By", key: "updater"}, 
        {label: "Update Time", key: "updateTime", type: "date"}, 
    ];
    const defaultFilter = Object.fromEntries(dataFrame.map(item => [item.key, item.default?item.default:""]));
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const allBillings = useMyStore(state => state.billings);
    const setBillings = useMyStore(state => state.setBillings);
    const userNames = useMyStore(state => state.userNames);
    const setUsers = useMyStore(state => state.setUserNames);
    const projectNames = useMyStore(state => state.projectNames);
    const setProjects = useMyStore(state => state.setProjectNames);
    const purchases = useMyStore(state => state.billingPurchases);
    const allWorkLogs = useMyStore(state => state.billingWorkLogs);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    const path3 = decodeURIComponent(path.split("/")[3] ?? "");
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Billings": allBillings.updatedAt === null?getTimeStamp():allBillings.updatedAt, 
        "Users": userNames.updatedAt === null?getTimeStamp():userNames.updatedAt, 
        "Projects": projectNames.updatedAt === null?getTimeStamp():projectNames.updatedAt, 
        "Purchases": purchases.updatedAt === null?getTimeStamp():purchases.updatedAt, 
        "Work Logs": allWorkLogs.updatedAt === null?getTimeStamp():allWorkLogs.updatedAt, 
    });
    //--------------------------------------------------------------------------------------------
    const [curApproval, setApproval] = useState(""); 
    const [showLoading, setShowLoading] = useState(false);
    const [curWeekStart, setWeekStart] = useState(weeknum(new MyDate()));
    const [curWeekEnd, setWeekEnd] = useState(weeknum(new MyDate()));
    const [curFilter, setFilter] = useState(defaultFilter);
    const [filterWords, setFilterWords] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    //-------------------------------------------------------------------------------------------- 
    const projects = projectNames.data;
    const users = userNames.data;
    const usersMap = Object.fromEntries(users.map(user => [user.email, `${user.userName}`]))
    const projectsListMap = Object.fromEntries(projects.map(project => [project.projectHashKey, project.projectName]))
    const billings = allBillings.data.filter(billing => 
        (billing.submitTime > getDatefromWeekNum(curWeekStart, 0)) &&  
       (billing.submitTime < getDatefromWeekNum(curWeekEnd, 7))
    ).map(billing => 
        ({...billing, 
            decision:
            JSON.parse(billing.approval).find(approvalLevel => approvalLevel.approverDecision === "Rejected")?
            "Rejected"
            :
            !JSON.parse(billing.approval).find(approvalLevel => approvalLevel.approverDecision !== "Approved")?
            "Approved"
            :
            "Submitted",
            projectName: projectsListMap[billing.projectHashKey],
            approval: JSON.stringify(JSON.parse(billing.approval).map(approvalLevel => ({
                ...approvalLevel, 
                candidate: 
                approvalLevel.candidateEmail.map(aEmail => usersMap[aEmail])
            }))),
            submitter: usersMap[billing.submitterEmail],
            updater: usersMap[billing.updaterEmail],
            requestor: usersMap[billing.requestorEmail],
        })
    );
    dataFrame[7].options = [{value: "", label: "Select"}, ...billings.map(billing => JSON.parse(billing.approval)).reduce(arrayReducer, []).map(approval => approval.candidateEmail).reduce(arrayReducer, []).filter(onlyUnique).map(email => ({value: email, label: usersMap[email]}))];
    const filteredBillings = billings.filter(u => 
        // (curFilter.void === "All"?true:(u.void === curFilter.void)) && 
        (curFilter.billingNumber?u.billingNumber.toLowerCase().includes(curFilter.billingNumber.toLowerCase()):true)
        && (curFilter.createdBy?u.submitterEmail === curFilter.createdBy:true)
        && (curFilter.updatedBy?u.updaterEmail === curFilter.updatedBy:true)
        && (curFilter.billed === "All"?true:u.billed === curFilter.billed)
        && (curFilter.decision === "All"?true:u.decision === curFilter.decision)
        && (
            curApproval === ""?true:
            (
                /*curApproval === "all"*/
                JSON.parse(u.approval).find(uu => 
                    uu.candidateEmail.includes(user.email)
                ) 
                &&
                (curApproval === "need"?
                    !JSON.parse(u.approval).every(uu => 
                        uu.approverDecision === "Approved"
                    ) && JSON.parse(u.approval).filter(uu => 
                        uu.approverDecision !== "Approved"
                    )[0].candidateEmail.includes(user.email)
                    :
                    true
                )
            )
        )
        && (curFilter.billable?u.billable === curFilter.billable:true)
        && (curFilter.startDateMin?new Date(u.startDate) >= new Date(curFilter.startDateMin):true)
        && (curFilter.startDateMax?new Date(u.startDate) <= new Date(curFilter.startDateMax):true)
        && (curFilter.endDateMin?new Date(u.endDate) >= new Date(curFilter.endDateMin):true)
        && (curFilter.endDateMax?new Date(u.endDate) <= new Date(curFilter.endDateMax):true)
        && (curFilter.submitTimeMin?new Date(u.submitTime) >= new Date(curFilter.submitTimeMin):true)
        && (curFilter.submitTimeMax?new Date(u.submitTime) <= new Date(curFilter.submitTimeMax):true)
        && (u.updateTime && curFilter.updateTimeMin?new Date(u.updateTime) >= new Date(curFilter.updateTimeMin):true)
        && (u.updateTime && curFilter.updateTimeMax?new Date(u.updateTime) <= new Date(curFilter.updateTimeMax):true)
        && (curFilter.amountMin?window.Number.parseFloat(u.amount) >= window.Number.parseFloat(curFilter.amountMin):true)
        && (curFilter.amountMax?window.Number.parseFloat(u.amount) <= window.Number.parseFloat(curFilter.amountMax):true)
        && (curFilter.projectName?u.projectName.toLowerCase().indexOf(curFilter.projectName.toLowerCase()) > -1:true)
        && (curFilter.notes?u.notes.toLowerCase().indexOf(curFilter.notes.toLowerCase()) > -1:true)
        && (curFilter.approver?curFilter.approver.toLowerCase().split(" ").map(aa => u.approval.toLowerCase().indexOf(aa) > -1).reduce(boolAndReducer, true):true)
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    );
    //--------------------------------------------------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentBillings = filteredBillings.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filteredBillings.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const deleteBilling = async e => {
        if(!window.confirm("Are you sure to void this Bill?")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("billingNumber", e.currentTarget.id);
        formData.append("voidReason", voidReason);
        formData.append("start", getDatefromWeekNum(curWeekStart, 0));
        formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("billings/deleteBilling.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setBillings(curWeekStart, curWeekEnd, res.data);
        history.replace(`/${path1}`);
        scroll(null);
    }
    const restoreBilling = async e => {
        if(!window.confirm("Are you sure to re-valid this billing?")) return;
        const formData = new MyFormData();
        formData.append("billingNumber", e.currentTarget.id);
        formData.append("start", getDatefromWeekNum(curWeekStart, 0));
        formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("billings/restoreBilling.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setBillings(curWeekStart, curWeekEnd, res.data);
        history.replace(`/${path1}`);
    }
    const notify = async e => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const formData = new MyFormData();
        formData.append("billingNumber", e.currentTarget.id);
        formData.append("start", getDatefromWeekNum(curWeekStart, 0));
        formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
        //-------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("billings/notify.php", formData);
        setShowLoader(false);
        if(!res) return;
        //-------------------------------------------------
        setBillings(curWeekStart, curWeekEnd, res.data);
        history.replace(`/${path1}`);
        scroll(null);
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect main");
            let realWeekStart = curWeekStart;
            let realWeekEnd = curWeekEnd;
            if(!["Add", ""].includes(path2)){
                const formData = new MyFormData();
                formData.append("billingNumber", path2);
                setShowLoading(true);
                const billingRes = await myAxios("billings/readBilling.php", formData, undefined, controller.signal);
                if(!isMounted) return;
                setShowLoading(false);
                if(!billingRes) return;
                const potentialBilling = billingRes.data;
                if(potentialBilling === ""){
                    history.replace(`/${path1}`);
                }else{
                    if(potentialBilling.void){setFilter(f => ({...f, void: "yes"}));}
                    realWeekStart = weeknum(potentialBilling.submitTime.substring(0, 10));
                    realWeekEnd = weeknum(potentialBilling.submitTime.substring(0, 10));
                    setWeekStart(realWeekStart);
                    setWeekEnd(realWeekEnd);
                }
            }
            const formData = new MyFormData();
            if(!(allBillings.weekStart && allBillings.weekEnd)){
                formData.append("start", getDatefromWeekNum(realWeekStart, 0));
                formData.append("end", getDatefromWeekNum(realWeekEnd, 7));
            }else if(allBillings.weekStart > realWeekStart && allBillings.weekEnd === realWeekEnd){
                formData.append("start", getDatefromWeekNum(realWeekStart, 0));
                formData.append("end", getDatefromWeekNum(allBillings.weekStart, 0));
            }else if(allBillings.weekStart === realWeekStart && allBillings.weekEnd < realWeekEnd){
                formData.append("start", getDatefromWeekNum(allBillings.weekEnd, 7));
                formData.append("end", getDatefromWeekNum(realWeekEnd, 7));
            }
            setShowLoading(true);
            const res = await myAxios("billings/readBillings.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            const curBillings = [...res.data, ...allBillings.data].sort((a, b) => a.submitTime > b.submitTime?1:-1);
            setBillings(
                !allBillings.weekStart || realWeekStart < allBillings.weekStart ? curWeekStart : allBillings.weekStart, 
                !allBillings.weekEnd || realWeekEnd > allBillings.weekEnd ? realWeekEnd : allBillings.weekEnd, 
                curBillings, 
                updateDateTime["Billings"]
            );
        }
        if(
            !(
                allBillings.weekStart && 
                allBillings.weekEnd && 
                allBillings.weekStart <= curWeekStart && 
                allBillings.weekEnd >= curWeekEnd
            ) ||
            allBillings.updatedAt !== updateDateTime["Billings"]
        ) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    },[curWeekStart, curWeekEnd, updateDateTime, allBillings, setBillings, history, path1, path2]);
    useEffect(() => {
        if(updateDateTime["Users"] === userNames.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect side users");
            setShowLoading(true);
            const resUser = await myAxios("billings/readBillingUsers.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resUser) return;
            setUsers(
                resUser.data, 
                updateDateTime["Users"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [updateDateTime, userNames.updatedAt, setUsers]);
    useEffect(() => {
        if(updateDateTime["Projects"] === projectNames.updatedAt) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async() => {
            if(isDevMode) console.log("useEffect side projects");
            setShowLoading(true);
            const resProject = await myAxios("billings/readBillingProjects.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resProject) return;
            setProjects(
                resProject.data, 
                updateDateTime["Projects"]
            );
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [updateDateTime, projectNames.updatedAt, setProjects]);
    useEffect(() => {
        if(path2 !== "" && path2 !== "Add"){
            const thisBilling = filteredBillings.find(billing => billing.billingNumber === path2);
            if(!thisBilling){
                setCurrentPage(1);
                return;
            }
            const hashkeys = filteredBillings
            .filter(u => u.void === thisBilling.void)
            .map(v => v.billingNumber);
            setCurrentPage(Math.ceil((hashkeys.indexOf(path2) + 1) / itemsPerPage));
            scroll(path2);
        }
    }, [filteredBillings, itemsPerPage, path2])
    useEffect(() => {
        if(path2){
            if(path3 !== "Edit") history.replace(`/${path1}/${path2}`);
            else history.replace(`/${path1}/${path2}/Edit`);
        }
    },[history, path1, path2, path3])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <button
                        type = "button"
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </button>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                {filteredBillings.find(billing =>
                    JSON.parse(billing.approval).find(approvalLevel => 
                        approvalLevel.candidateEmail.includes(user.email)
                    )
                )?
                <span className = "d-flex align-items-center">
                    <label htmlFor = "approval" className = "mb-0">Approval:</label>
                    <select
                        id = "approval"
                        className = "form-control w-auto ml-2"
                        value = {curApproval}
                        onChange = {e => {
                            const value = e.currentTarget.value
                            setApproval(value);
                            // code here
                            history.push(`/${path1}`);
                            setCurrentPage(1);
                        }}
                    >
                        <option value = "">All Billings</option>
                        <option value = "all">All My Approval</option>
                        <option value = "need">Need My Approval</option>
                    </select>
                </span>
                :<></>}
                <WeekSelect
                    curWeekStart = {curWeekStart}
                    setWeekStart = {setWeekStart}
                    curWeekEnd = {curWeekEnd}
                    setWeekEnd = {setWeekEnd}
                    setCurrentPage = {setCurrentPage}
                    history = {history}
                    path1 = {path1}
                    beginWeek = "2022/8/11"
                />
                <DataFilter
                    setCurrentPage = {setCurrentPage}
                    curFilter = {curFilter}
                    setFilter = {setFilter}
                    defaultFilter = {defaultFilter}
                    items = {billings}
                    dataFrame = {dataFrame}
                    width = {"60rem"}
                    minWidth = {"40rem"}
                />
                {filteredBillings.length?
                <Export
                    usersMap = {usersMap}
                    filteredBillings = {filteredBillings}
                />
                :<></>}
                <button type = "button" className = "headerButton" onClick = {() => {
                    history.push(`/${path1}/Add`);
                }}>Add</button>
                {path2 === "Add"?
                <BillingForm
                    keyword = "Add"
                    closeIt = {() => {
                        history.push(`/${path1}`);
                    }}
                    updateDateTime = {updateDateTime}
                    curWeekStart = {curWeekStart}
                    curWeekEnd = {curWeekEnd}
                    users = {users}
                    projects = {projects}
                />:<></>}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredBillings.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead>
                            <tr className = "noBorderTop">
                                <th></th>
                                <th>Billing Number</th>
                                <th>Project</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Amount ($)</th>
                                <th>Submitter</th>
                                <th>Submit Time</th>
                                <th>Updater</th>
                                <th>Update Time</th>
                                <th>PDF</th>
                                <th>Status</th>
                                <th>Billed</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentBillings.map((billing, key) => 
                            <Fragment key = {key}>
                            <tr
                            style = {{
                                color: simpleStatusColorCode[billing.decision]
                            }}>
                                <td>
                                    <button
                                        type = "button"
                                        id = {billing.billingNumber}
                                        className = {(path2 === billing.billingNumber?"showMinus":"showPlus") + " childRow"}
                                        onClick = {e => {
                                            if(path2 !== e.currentTarget.id){
                                                history.push(`/${path1}/${e.currentTarget.id}`);
                                                scroll(e.currentTarget.id);
                                            }else{
                                                history.push(`/${path1}`);
                                                scroll(null);
                                            }
                                        }}
                                    />
                                </td>
                                <td>{billing.billingNumber}</td>
                                <td>
                                    <Link to = {`/Projects/${billing.projectHashKey}`}>
                                        {projectsListMap[billing.projectHashKey]}
                                    </Link>
                                </td>
                                <td>{billing.startDate}</td>
                                <td>{billing.endDate}</td>
                                <td>{billing.amount}</td>
                                <td>
                                    {billing.submitterEmail?
                                    <UserInfo 
                                        name = {billing.submitter}
                                        email = {billing.submitterEmail}
                                    />
                                    :<></>}
                                </td>
                                <td>{billing.submitTime}</td>
                                <td>
                                    {billing.updaterEmail?
                                    <UserInfo 
                                        name = {billing.updater}
                                        email = {billing.updaterEmail}
                                    />
                                    :<></>}
                                </td>
                                <td>{billing.updateTime ?? ""}</td>
                                <td>
                                    {billing.pdfId?
                                    <a
                                        id = {billing.billingNumber + " pdf"}
                                        className = "btn btn-primary"
                                        href = {`https://drive.google.com/file/d/${billing.pdfId}/view?usp=drivesdk`}
                                        target = "_blank"
                                        rel = "noreferrer"
                                    >
                                        View
                                    </a>:<></>}
                                </td>
                                <td>
                                    {billing.decision}
                                </td>
                                <td>
                                    {billing.billed?"yes":"no"}
                                </td>
                                <td>
                                    {billing.decision === "Approved"?
                                    <button type = "button" id = {billing.billingNumber + " bill"} className = {`btn btn-${billing.billed?"danger":"success"}`} onClick = {async() => {
                                        if(!window.confirm(`Are you sure to set this as ${billing.billed?"unbilled":"billed"}?`)) return;
                                        const formData = new MyFormData();
                                        formData.append("billingNumber", billing.billingNumber);
                                        formData.append("billed", billing.billed?"":"yes");
                                        formData.append("start", getDatefromWeekNum(curWeekStart, 0));
                                        formData.append("end", getDatefromWeekNum(curWeekEnd, 7));
                                        //-------------------------------------------------
                                        setShowLoader(true);
                                        const res = await myAxios("billings/billed.php", formData);
                                        setShowLoader(false);
                                        if(!res) return;
                                        //-------------------------------------------------
                                        setBillings(curWeekStart, curWeekEnd, res.data);
                                        history.replace(`/${path1}`);
                                        scroll(null);
                                    }}>{billing.billed?"Set unsent":"Set sent"}</button>
                                    :<></>}
                                </td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                <TransitionWidthHeight 
                                    classNames = "cssTDTransition"
                                    In = {path2 ===  billing.billingNumber}
                                >
                                    <Detail
                                        updateDateTime = {updateDateTime}
                                        curWeekStart = {curWeekStart}
                                        curWeekEnd = {curWeekEnd}
                                        deleteBilling = {deleteBilling}
                                        restoreBilling = {restoreBilling}
                                        notify = {notify}
                                        editBilling = {() => {
                                            history.push(`/${path1}/${path2}/Edit`);
                                        }}
                                        users = {users}
                                        usersMap = {usersMap}
                                        projects = {projects}
                                        billing = {billing}
                                        history = {history}
                                        path1 = {path1}
                                        path2 = {path2}
                                        path3 = {path3}
                                        setShowLoader = {setShowLoader}
                                        user = {user}
                                        setBillings = {setBillings}
                                    />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filteredBillings.length?
                <Footer
                    length = {filteredBillings.length}
                    pageNumbers = {pageNumbers}
                    
                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}

                    paginateAction = {() => history.push(`/${path1}`)}
                />
                :null}
            </div>
        </div>
    )
}





